import { render, staticRenderFns } from "./EntranceReport.vue?vue&type=template&id=5a52c71e"
import script from "./EntranceReport.vue?vue&type=script&lang=js"
export * from "./EntranceReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports